export default "__VITE_ASSET__BqSsqR7O__"